import { Urls_PatientPage, Urls_Page, Controls_containerWithContent } from "./Common/General.js";
import { view } from "./Auth/LoginView.js";
import { Sidebar_$007CShowBurger$007CHideBurger$007C, AppState_sidebarMode, Msg } from "./Types.js";
import { view as view_1 } from "./Auth/MfaVerifyView.js";
import { viewRequestResetEmail, view as view_2 } from "./Auth/ResetPasswordView.js";
import { view as view_3 } from "./Auth/RegisterView.js";
import { view as view_4 } from "./Institution/InstitutionView.js";
import { view as view_5 } from "./User/UserView.js";
import { map, bind, defaultArg, value as value_10 } from "./fable_modules/fable-library-js.4.19.3/Option.js";
import * as react from "react";
import { keyValueList } from "./fable_modules/fable-library-js.4.19.3/MapUtil.js";
import { view as view_6 } from "./Study/StudyView.js";
import { view as view_7 } from "./FileManagement/FileUploadParentExample/FileParentView.js";
import { view as view_8 } from "./Patient/PatientView.js";
import { view as view_9 } from "./SystemInformation/SystemInformationView.js";
import { Option, button } from "./fable_modules/Fulma.3.0.0/Elements/Button.fs.js";
import { collect, map as map_1, tryExactlyOne, tryFind, singleton, empty, ofArray } from "./fable_modules/fable-library-js.4.19.3/List.js";
import { Option as Option_1, icon as icon_1 } from "./fable_modules/Fulma.3.0.0/Elements/Icon.fs.js";
import { Fa_IconOption, Fa_i } from "./fable_modules/Fable.FontAwesome.3.0.0/FontAwesome.fs.js";
import { Option as Option_4, Burger_Option, burger, Item_div, End_div, menu as menu_1, Item_Option, Item_a, Brand_div, navbar as navbar_1 } from "./fable_modules/Fulma.3.0.0/Components/Navbar.fs.js";
import { Common_EmailAddress_value_Z39D6D3C1 } from "./fable_modules/Webbler.Models.1.6.0/Api.fs.js";
import { isNullOrEmpty, split, printf, toText, join } from "./fable_modules/fable-library-js.4.19.3/String.js";
import { UserRole_get_describe } from "./RAWMap.Models/Security.js";
import { Common_GenericOption, Modifier_IModifier, Screen } from "./fable_modules/Fulma.3.0.0/Common.fs.js";
import { right, Item_Option as Item_Option_1, item, Level_Option, level } from "./fable_modules/Fulma.3.0.0/Layouts/Level.fs.js";
import { sessionExpiryModal, view as view_10 } from "./Auth/AuthView.js";
import { canViewPage } from "./Routing.js";
import { panel as panel_1, icon as icon_2, Block_Option, Block_a } from "./fable_modules/Fulma.3.0.0/Components/Panel.fs.js";
import { empty as empty_1, singleton as singleton_1, append, delay, toList } from "./fable_modules/fable-library-js.4.19.3/Seq.js";
import { HTMLAttr, DOMAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { comparePrimitives, defaultOf, equals } from "./fable_modules/fable-library-js.4.19.3/Util.js";
import { Option as Option_2, ISize, column } from "./fable_modules/Fulma.3.0.0/Layouts/Column.fs.js";
import { content as content_16 } from "./fable_modules/Fulma.3.0.0/Elements/Content.fs.js";
import { Helpers_nothing } from "./fable_modules/Fable.React.9.4.0/Fable.React.Helpers.fs.js";
import { Option as Option_3, columns } from "./fable_modules/Fulma.3.0.0/Layouts/Columns.fs.js";
import { now, year } from "./fable_modules/fable-library-js.4.19.3/Date.js";
import { ofArray as ofArray_1, tryFind as tryFind_1 } from "./fable_modules/fable-library-js.4.19.3/Map.js";
import { item as item_1, equalsWith, map as map_2 } from "./fable_modules/fable-library-js.4.19.3/Array.js";

export function root(model, dispatch) {
    let props_6, children_6, props_8, props_10, children_10, arg_18, children_30;
    let content_14;
    const matchValue = model.CurrentPage;
    let matchResult, pid, _sid, pid_1;
    switch (matchValue.tag) {
        case 2: {
            matchResult = 5;
            break;
        }
        case 3: {
            if (model.AuthModel.userInfo != null) {
                matchResult = 6;
            }
            else {
                matchResult = 7;
            }
            break;
        }
        case 4: {
            matchResult = 8;
            break;
        }
        case 5: {
            matchResult = 9;
            break;
        }
        case 1: {
            matchResult = 10;
            break;
        }
        case 6: {
            switch (matchValue.fields[0].tag) {
                case 2: {
                    if (matchValue.fields[0].fields[0][1] != null) {
                        matchResult = 14;
                        _sid = matchValue.fields[0].fields[0][1];
                        pid_1 = matchValue.fields[0].fields[0][0];
                    }
                    else {
                        matchResult = 12;
                        pid = matchValue.fields[0].fields[0][0];
                    }
                    break;
                }
                case 1: {
                    if (matchValue.fields[0].fields[0] == null) {
                        matchResult = 13;
                    }
                    else {
                        matchResult = 12;
                        pid = matchValue.fields[0].fields[0];
                    }
                    break;
                }
                default:
                    matchResult = 11;
            }
            break;
        }
        case 7: {
            matchResult = 15;
            break;
        }
        default:
            switch (matchValue.fields[0].tag) {
                case 1: {
                    matchResult = 1;
                    break;
                }
                case 2: {
                    matchResult = 2;
                    break;
                }
                case 3: {
                    matchResult = 3;
                    break;
                }
                case 4: {
                    matchResult = 4;
                    break;
                }
                default:
                    matchResult = 0;
            }
    }
    switch (matchResult) {
        case 0: {
            content_14 = Controls_containerWithContent("Login", view(model.AuthModel, (arg) => {
                dispatch(new Msg(2, [arg]));
            }));
            break;
        }
        case 1: {
            content_14 = Controls_containerWithContent("Verify", view_1(model.AuthModel, (arg_1) => {
                dispatch(new Msg(2, [arg_1]));
            }));
            break;
        }
        case 2: {
            content_14 = Controls_containerWithContent("Reset Password", view_2(model.AuthModel.resetPasswordModel, (arg_2) => {
                dispatch(new Msg(2, [arg_2]));
            }));
            break;
        }
        case 3: {
            content_14 = Controls_containerWithContent("Reset Password", viewRequestResetEmail(model.AuthModel.resetPasswordModel.resetRequestEmail, (arg_3) => {
                dispatch(new Msg(2, [arg_3]));
            }));
            break;
        }
        case 4: {
            content_14 = Controls_containerWithContent("Register", view_3(model.AuthModel, (arg_4) => {
                dispatch(new Msg(2, [arg_4]));
            }));
            break;
        }
        case 5: {
            content_14 = Controls_containerWithContent("Institutions", view_4(model.InstitutionsModel, (arg_5) => {
                dispatch(new Msg(5, [arg_5]));
            }));
            break;
        }
        case 6: {
            content_14 = Controls_containerWithContent("Users", view_5(model.UsersModel, value_10(model.AuthModel.userInfo), (arg_6) => {
                dispatch(new Msg(6, [arg_6]));
            }));
            break;
        }
        case 7: {
            const props = [["style", {
                textAlign: "center",
                padding: 20,
            }]];
            content_14 = react.createElement("div", keyValueList(props, 1), "You are not logged in");
            break;
        }
        case 8: {
            content_14 = Controls_containerWithContent("Study", view_6("00000000-0000-0000-0000-000000000000", model.StudyModel, (arg_7) => {
                dispatch(new Msg(7, [arg_7]));
            }));
            break;
        }
        case 9: {
            const children_2 = [Controls_containerWithContent("FileManagement", view_7(model.FileManagementModel, (arg_8) => {
                dispatch(new Msg(8, [arg_8]));
            }))];
            content_14 = react.createElement("div", {}, ...children_2);
            break;
        }
        case 10: {
            const props_4 = [["style", {
                textAlign: "center",
                padding: 20,
            }]];
            content_14 = react.createElement("div", keyValueList(props_4, 1), "Welcome home");
            break;
        }
        case 11: {
            content_14 = Controls_containerWithContent("Patients", view_8(model.PatientsModel, (arg_9) => {
                dispatch(new Msg(12, [arg_9]));
            }));
            break;
        }
        case 12: {
            content_14 = Controls_containerWithContent("Study", view_6(pid, model.StudyModel, (arg_10) => {
                dispatch(new Msg(7, [arg_10]));
            }));
            break;
        }
        case 13: {
            content_14 = Controls_containerWithContent("Patients", view_8(model.PatientsModel, (arg_11) => {
                dispatch(new Msg(12, [arg_11]));
            }));
            break;
        }
        case 14: {
            content_14 = Controls_containerWithContent("Study", view_6(pid_1, model.StudyModel, (arg_12) => {
                dispatch(new Msg(7, [arg_12]));
            }));
            break;
        }
        default:
            content_14 = Controls_containerWithContent("System Information", view_9(model.SystemInformationModel, (arg_13) => {
                dispatch(new Msg(13, [arg_13]));
            }));
    }
    const lightModeButton = button(ofArray([new Option(18, [(_arg_1) => {
        const topDiv = document.getElementById("app-container");
        const value = topDiv.classList.remove("theme-dark");
        const value_1 = topDiv.classList.add("theme-light");
        document.cookie = "theme=light";
    }]), new Option(4, [])]), singleton(icon_1(empty(), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-sun"])), [])))));
    const darkModeButton = button(ofArray([new Option(18, [(_arg_2) => {
        const topDiv_1 = document.getElementById("app-container");
        const value_2 = topDiv_1.classList.remove("theme-light");
        const value_3 = topDiv_1.classList.add("theme-dark");
        document.cookie = "theme=dark";
    }]), new Option(4, [])]), singleton(icon_1(empty(), singleton(Fa_i(singleton(new Fa_IconOption(11, ["fas fa-moon"])), [])))));
    const showInstitution = defaultArg(bind((ui) => bind((iid) => map((i_1) => i_1.name, tryFind((i) => (i.id === iid), model.InstitutionsModel.Institutions)), tryExactlyOne(ui.userData.institutions)), model.AuthModel.userInfo), "");
    const maybeActivePatientInstDesignation = bind((patient) => {
        const _arg_3 = tryFind((i_2) => (i_2.id === patient.institutionId), model.UsersModel.institutions);
        if (_arg_3 == null) {
            return undefined;
        }
        else {
            return _arg_3.clinicalDesignation;
        }
    }, model.PatientsModel.SelectedPatient);
    let navbar;
    const matchValue_1 = model.AuthModel.userInfo;
    if (matchValue_1 == null) {
        navbar = navbar_1(empty(), singleton(Brand_div(empty(), singleton(Item_a(empty(), singleton(react.createElement("img", {
            src: "logo.png",
        })))))));
    }
    else {
        const ui_1 = matchValue_1;
        let describeUser;
        const children_12 = [(props_6 = [["style", {
            marginRight: 10,
        }]], (children_6 = [Common_EmailAddress_value_Z39D6D3C1(ui_1.email)], react.createElement("span", keyValueList(props_6, 1), ...children_6))), (props_8 = [["style", {
            marginRight: 10,
        }]], react.createElement("span", keyValueList(props_8, 1), showInstitution)), (props_10 = [["style", {
            color: "#BBBBBB",
        }]], (children_10 = [join(",", map_1(UserRole_get_describe(), ui_1.roles))], react.createElement("span", keyValueList(props_10, 1), ...children_10)))];
        describeUser = react.createElement("div", {}, ...children_12);
        navbar = navbar_1(empty(), ofArray([Brand_div(empty(), ofArray([Item_a(empty(), singleton(react.createElement("img", {
            src: "logo.png",
        }))), Item_a(ofArray([new Item_Option(7, [singleton(new Modifier_IModifier(24, [new Screen(1, []), true]))]), new Item_Option(5, [singleton(["style", {
            flexGrow: 1,
        }])])]), singleton(level(ofArray([new Level_Option(0, [singleton(["style", {
            flexGrow: 1,
        }])]), new Level_Option(1, [])]), ofArray([item(singleton(new Item_Option_1(0, [singleton(["style", {
            flexGrow: 1,
        }])])), empty()), right(empty(), singleton(item(empty(), singleton(view_10(model.AuthModel, (arg_14) => {
            dispatch(new Msg(2, [arg_14]));
        })))))]))))])), menu_1(empty(), singleton(End_div(empty(), ofArray([defaultArg(map((_ui) => Item_div(empty(), singleton(describeUser)), model.AuthModel.userInfo), react.createElement("div", {})), Item_div(empty(), singleton(view_10(model.AuthModel, (arg_15) => {
            dispatch(new Msg(2, [arg_15]));
        })))]))))]));
    }
    let menu;
    if (model.AuthModel.userInfo == null) {
        menu = react.createElement("div", {});
    }
    else {
        const pages = collect((page) => {
            let linkedPage;
            if (canViewPage(page.Page, model)) {
                return singleton((linkedPage = page.Page, Block_a(toList(delay(() => append(singleton_1(new Block_Option(1, [ofArray([new DOMAttr(40, [(_arg) => {
                    dispatch(new Msg(1, [linkedPage]));
                }]), ["style", {
                    paddingRight: "2rem",
                }]])])), delay(() => (equals(linkedPage, model.CurrentPage) ? singleton_1(new Block_Option(0, [true])) : empty_1()))))), ofArray([icon_2(empty(), singleton(icon_1(singleton(new Option_1(4, [singleton(["style", {
                    justifyContent: "revert",
                    alignItems: "baseline",
                }])])), singleton(Fa_i(singleton(page.Icon), []))))), page.Label]))));
            }
            else {
                return empty();
            }
        }, ofArray([{
            Icon: new Fa_IconOption(11, ["fas fa-home"]),
            Label: "Dashboard",
            Page: new Urls_Page(1, []),
        }, {
            Icon: new Fa_IconOption(11, ["fas fa-users"]),
            Label: "Users",
            Page: new Urls_Page(3, []),
        }, {
            Icon: new Fa_IconOption(11, ["fas fa-hospital"]),
            Label: "Institutions",
            Page: new Urls_Page(2, []),
        }, {
            Icon: new Fa_IconOption(11, ["fas fa-users"]),
            Label: "Patients",
            Page: new Urls_Page(6, [new Urls_PatientPage(0, [])]),
        }, {
            Icon: new Fa_IconOption(11, ["fas fa-file-alt"]),
            Label: "FileManagement",
            Page: new Urls_Page(5, []),
        }, {
            Icon: new Fa_IconOption(11, ["fas fa-info-circle"]),
            Label: "System Information",
            Page: new Urls_Page(7, []),
        }]));
        const panel = (content_15) => panel_1(empty(), toList(delay(() => content_15)));
        const sidebarMode = AppState_sidebarMode(model);
        let hamburger;
        const children_22 = [burger(ofArray([new Burger_Option(0, [model.MenuIsExpanded]), new Burger_Option(2, [ofArray([new DOMAttr(40, [(_e) => {
            dispatch(new Msg(14, [!model.MenuIsExpanded]));
        }]), new HTMLAttr(135, ["button"]), ["style", {
            marginLeft: "0px",
            display: "block",
        }]])])]), ofArray([react.createElement("span", {}), react.createElement("span", {}), react.createElement("span", {})]))];
        hamburger = react.createElement("div", {}, ...children_22);
        menu = column(ofArray([new Option_2(0, [new Screen(0, []), new ISize(17, [])]), new Option_2(3, [ofArray([new HTMLAttr(99, ["sidebar-nav"]), new HTMLAttr(64, ["side-menu"])])])]), singleton(content_16(empty(), toList(delay(() => append((Sidebar_$007CShowBurger$007CHideBurger$007C(sidebarMode).tag === 1) ? singleton_1(Helpers_nothing) : singleton_1(hamburger), delay(() => {
            let props_28, children_24;
            const matchValue_4 = sidebarMode;
            return (matchValue_4.tag === 1) ? ((matchValue_4.fields[0].tag === 0) ? singleton_1((props_28 = [new HTMLAttr(64, ["expanded-menu"]), ["style", {
                position: "absolute",
                zIndex: 2,
            }]], (children_24 = [panel(pages)], react.createElement("div", keyValueList(props_28, 1), ...children_24)))) : singleton_1(Helpers_nothing)) : singleton_1(panel(pages));
        })))))));
    }
    let footerContents;
    let patternInput;
    const matchValue_5 = model.CurrentPage;
    let matchResult_1;
    if (maybeActivePatientInstDesignation != null) {
        if (maybeActivePatientInstDesignation.tag === 1) {
            switch (matchValue_5.tag) {
                case 4: {
                    matchResult_1 = 1;
                    break;
                }
                case 6: {
                    switch (matchValue_5.fields[0].tag) {
                        case 1:
                        case 2: {
                            matchResult_1 = 1;
                            break;
                        }
                        default:
                            matchResult_1 = 2;
                    }
                    break;
                }
                default:
                    matchResult_1 = 2;
            }
        }
        else {
            switch (matchValue_5.tag) {
                case 4: {
                    matchResult_1 = 0;
                    break;
                }
                case 6: {
                    switch (matchValue_5.fields[0].tag) {
                        case 1:
                        case 2: {
                            matchResult_1 = 0;
                            break;
                        }
                        default:
                            matchResult_1 = 2;
                    }
                    break;
                }
                default:
                    matchResult_1 = 2;
            }
        }
    }
    else {
        matchResult_1 = 2;
    }
    switch (matchResult_1) {
        case 0: {
            patternInput = ["WARNING: For Research Use Only.", defaultArg(map((x) => x.researchProductName, model.SystemInformationModel.maybeCurrentSystemInformation), ""), "footer-level-warning"];
            break;
        }
        case 1: {
            patternInput = ["WARNING: United States Federal law restricts this device to sale by or on the order of a physician.", defaultArg(map((x_1) => x_1.clinicalProductName, model.SystemInformationModel.maybeCurrentSystemInformation), ""), "footer-level-warning"];
            break;
        }
        default:
            patternInput = ["", "", "footer-level"];
    }
    footerContents = Brand_div(singleton(new Common_GenericOption(1, [singleton(["style", {
        flexGrow: "1",
        minHeight: "inherit",
    }])])), singleton(columns(ofArray([new Option_3(9, [singleton(new HTMLAttr(99, ["footer-level"]))]), new Option_3(4, []), new Option_3(1, [])]), ofArray([react.createElement("div", {
        className: "theme-button-container",
    }, lightModeButton, darkModeButton), column(singleton(new Option_2(3, [singleton(new HTMLAttr(99, [patternInput[2]]))])), singleton(patternInput[0])), column(singleton(new Option_2(3, [singleton(["style", {
        textAlign: "center",
    }])])), singleton((arg_18 = (year(now()) | 0), toText(printf("© %d ViTAA Medical Solutions"))(arg_18)))), column(singleton(new Option_2(3, [singleton(["style", {
        textAlign: "right",
    }])])), singleton(patternInput[1]))]))));
    let theme;
    const matchValue_7 = tryFind_1("theme", ofArray_1(map_2((s_18) => {
        const kvArr = split(s_18.trim(), ["="], undefined, 0);
        if (!equalsWith((x_2, y) => (x_2 === y), kvArr, defaultOf()) && (kvArr.length === 2)) {
            const v = item_1(1, kvArr);
            return [item_1(0, kvArr), v];
        }
        else {
            return ["", ""];
        }
    }, split(document.cookie, [";"], undefined, 0)), {
        Compare: comparePrimitives,
    }));
    let matchResult_2;
    if (matchValue_7 != null) {
        switch (matchValue_7) {
            case "dark": {
                matchResult_2 = 0;
                break;
            }
            default:
                matchResult_2 = 1;
        }
    }
    else {
        matchResult_2 = 1;
    }
    switch (matchResult_2) {
        case 0: {
            theme = "theme-dark";
            break;
        }
        default:
            theme = "theme-light";
    }
    document.getElementById("app-container").classList.add(theme);
    const children_32 = [navbar, (children_30 = [columns(ofArray([new Option_3(3, []), new Option_3(9, [singleton(["style", {
        marginBottom: "0px",
    }])])]), ofArray([menu, column(empty(), singleton(content_14))]))], react.createElement("div", {}, ...children_30)), sessionExpiryModal(model.AuthModel.inactivity, (arg_19) => {
        dispatch(new Msg(2, [arg_19]));
    }), navbar_1(ofArray([new Option_4(6, [singleton(new HTMLAttr(99, ["footer-desktop"]))]), new Option_4(4, []), new Option_4(2, []), new Option_4(8, [singleton(new Modifier_IModifier(24, [new Screen(5, []), true]))])]), singleton(footerContents)), navbar_1(ofArray([new Option_4(6, [singleton(new HTMLAttr(99, ["footer-touch"]))]), new Option_4(8, [singleton(new Modifier_IModifier(24, [new Screen(1, []), true]))])]), singleton(footerContents))];
    return react.createElement("div", {
        onDrop: (e) => {
            const droppedItem = e.dataTransfer.files.item(0);
            if (!isNullOrEmpty(droppedItem.type)) {
                e.preventDefault();
            }
        },
    }, ...children_32);
}

